import React, { FC, memo } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import ConsumerBillingList from '../ConsumerBillingList';
import ConsumerIntegrationsList from '../ConsumerIntegrationsList';
import ConsumerTokensList from '../ConsumerTokensList';
import ConsumerReferralsList from '../ConsumerReferralsList';
import { ConsumerBilling, ConsumerIntegration } from '../consumer.types';
import cls from './ConsumerTabsPanel.module.scss';

type ConsumerTabsPanelProps = {
  consumerId: string;
  consumerBillingList: ConsumerBilling[] | undefined;
  consumerIntegrationsList: ConsumerIntegration[] | undefined;
  consumerBillingListLoading: boolean;
  consumerIntegrationsLoading: boolean;
  operationsPage: number;
  setOperationsPage: React.Dispatch<React.SetStateAction<number>>;
  scrollOperationsList: ConsumerBilling[];
  setScrollOperationsList: React.Dispatch<React.SetStateAction<ConsumerBilling[]>>;
  integrationsPage: number;
  setIntegrationsPage: React.Dispatch<React.SetStateAction<number>>;
  selectedHandler: (value: string | null) => void;
  isB2B: boolean;
};
const ConsumerTabsPanel: FC<ConsumerTabsPanelProps> = memo(
  ({
    consumerId,
    consumerBillingList,
    consumerBillingListLoading,
    consumerIntegrationsList,
    consumerIntegrationsLoading,
    operationsPage,
    setOperationsPage,
    scrollOperationsList,
    setScrollOperationsList,
    integrationsPage,
    setIntegrationsPage,
    selectedHandler,
    isB2B,
  }) => {
    return (
      <div className={cls.Container} data-testid="consumer-tabs-panel">
        <Tabs
          defaultActiveKey={isB2B ? 'logs' : 'tokens'}
          onSelect={(value) => selectedHandler(value)}
          variant="underline"
        >
          {isB2B ? (
            <Tab eventKey="logs" title="Operations history" data-testid="consumer-operations-tab">
              <ConsumerBillingList
                consumerBillingList={consumerBillingList}
                operationsPage={operationsPage}
                setOperationsPage={setOperationsPage}
                scrollOperationsList={scrollOperationsList}
                setScrollOperationsList={setScrollOperationsList}
                consumerBillingListLoading={consumerBillingListLoading}
              />
            </Tab>
          ) : (
            <Tab eventKey="tokens" title="Tokens history" data-testid="consumer-tokens-tab">
              <ConsumerTokensList />
            </Tab>
          )}
          {!isB2B && (
            // the referral program is B2C only; mounted on first open, so the card does not ask billing up front
            <Tab eventKey="referrals" title="Referrals" mountOnEnter>
              <ConsumerReferralsList consumerId={consumerId} />
            </Tab>
          )}
          <Tab eventKey="integrations" title="Integrations" data-testid="consumer-integrations-tab">
            <ConsumerIntegrationsList
              consumerIntegrations={consumerIntegrationsList}
              isLoading={consumerIntegrationsLoading}
              page={integrationsPage}
              setPage={setIntegrationsPage}
            />
          </Tab>
        </Tabs>
      </div>
    );
  },
);

export default ConsumerTabsPanel;
